module.exports = __webpack_public_path__ + "img/active-feature-bullet-bg.579dc29.png";